var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-text-field',{attrs:{"value":_vm.value,"rules":[_vm.rules.required, _vm.rules.isEmail],"label":_vm.label,"append-icon":"email","solo":_vm.solo},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }